import { NavBarItemWithLink } from 'components/Core/Navbar';
import { ReactComponent as BellIcon } from 'assets/navbar/navbar_bell.svg';
import { ReactComponent as ShopIcon } from 'assets/navbar/navbar_shop.svg';
import { ReactComponent as BrandsIcon } from 'assets/navbar/navbar_brands.svg';
import { ReactComponent as PeopleIcon } from 'assets/navbar/navbar_people.svg';
import { ReactComponent as DiscountIcon } from 'assets/navbar/navbar_sale.svg';
import { ReactComponent as ReviewsIcon } from 'assets/navbar/navbar_reviews.svg';
import { ReactComponent as ProductsIcon } from 'assets/navbar/navbar_product.svg';
import { ReactComponent as ParsersIcon } from 'assets/navbar/navbar_sync.svg';
import { ReactComponent as GlobeIcon } from 'assets/navbar/globe.svg';
import { ReactComponent as ScriptsIcon } from 'assets/navbar/navbar_scripts.svg';
import { ReactComponent as SearchCoverageIcon } from 'assets/search_icon.svg';

export const iconProps = { width: '100%', height: '100%' };

export const pointsNavItem: NavBarItemWithLink = {
  icon: <ShopIcon {...iconProps} />,
  label: 'points',
  link: { path: '/points', exact: true },
  // disable: true,
};

export const brandsNavItem: NavBarItemWithLink = {
  icon: <BrandsIcon {...iconProps} />,
  label: 'brands',
  link: { path: '/brands', exact: true },
  // disable: true,
};

export const usersNavItem: NavBarItemWithLink = {
  icon: <PeopleIcon {...iconProps} />,
  label: 'users',
  link: { path: '/users', exact: true },
  // disable: true,
};

export const adminUsersNavItem: NavBarItemWithLink = {
  icon: <PeopleIcon {...iconProps} />,
  label: 'adminUsers',
  link: { path: '/admin-users', exact: true },
  // disable: true,
};

export const requestsNavItem: NavBarItemWithLink = {
  icon: <BellIcon {...iconProps} />,
  label: 'requests',
  link: { path: '/requests', exact: true },
};

export const discountsNavItem: NavBarItemWithLink = {
  icon: <DiscountIcon {...iconProps} />,
  label: 'discounts',
  link: { path: '/discounts', exact: true },
  disable: true,
};

export const reviewsNavItem: NavBarItemWithLink = {
  icon: <ReviewsIcon {...iconProps} />,
  label: 'reviews',
  link: {
    path: '/reviews',
    exact: true,
  },
};

export const productsNavItem: NavBarItemWithLink = {
  icon: <ProductsIcon {...iconProps} />,
  label: 'products',
  link: {
    path: '/products',
    exact: true,
  },
};

export const parsersNavItem: NavBarItemWithLink = {
  icon: <ParsersIcon {...iconProps} />,
  label: 'parsers',
  link: {
    path: '/parsers',
    exact: true,
  },
};

export const countriesNavItem: NavBarItemWithLink = {
  icon: <GlobeIcon {...iconProps} />,
  label: 'countries',
  link: {
    path: '/countries',
    exact: true,
  },
};

export const popularProductsNavItem: NavBarItemWithLink = {
  icon: <ProductsIcon {...iconProps} />,
  label: 'popularProducts',
  link: {
    path: '/popular-products',
    exact: true,
  },
};

export const categoriesNavItem: NavBarItemWithLink = {
  icon: <DiscountIcon {...iconProps} />,
  label: 'categories',
  link: { path: '/categories', exact: true },
};

export const scriptsNavItem: NavBarItemWithLink = {
  icon: <ScriptsIcon {...iconProps} />,
  label: 'scripts',
  link: { path: '/scripts', exact: true },
};

export const searchCoverageNavItem: NavBarItemWithLink = {
  icon: <SearchCoverageIcon {...iconProps} />,
  label: 'searchCoverage',
  link: { path: '/search-coverage', exact: true },
};
